import React from "react";
import { Card, Button, Form, Row, Col } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { motion } from "framer-motion";

export default function TreatmentSidebar() {
  const location = useLocation();

  const treatments = [
  { name: "Acne & Scar", path: "/treatments/acne" },
  { name: "Tattoo Removal", path: "/treatments/tattoo" },
  { name: "Hair Treatment", path: "/treatments/hair" },
  { name: "Carbon Laser Facial", path: "/treatments/carbonlaser" },
  { name: "Anti-Aging", path: "/treatments/antiaging" },
  { name: "Laser Hair Removal", path: "/treatments/laserhair" },
  { name: "Fungal Infection", path: "/treatments/fungalinfection" },
  { name: "Eczema & Psoriasis", path: "/treatments/eczema-psoriasis" },
  { name: "Nail Disease & Treatment", path: "/treatments/nail-disease" },
  { name: "Chemical Peeling", path: "/treatments/chemicalpeel" },
  { name: "Platelet Rich Plasma (PRP)", path: "/treatments/prp" },
  { name: "Microneedling", path: "/treatments/microneedling" },
  { name: "Skin Glow", path: "/treatments/skinglow" },
  { name: "Skin Tag / Birthmark / Mole / Wart Removal", path: "/treatments/skintag-removal" },
];


  const iconStyle = {
    transition: "color 0.3s",
    cursor: "pointer",
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { type: "spring", stiffness: 90, damping: 15 } 
    },
  };

  return (
    <>
      {/* Treatments List Card */}
      <motion.div
        className="mb-4"
        variants={cardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Card className="shadow-sm">
          <Card.Body>
            <h5 className="fw-bold mb-3">All Treatments</h5>
            <ul className="list-unstyled mb-0">
              {treatments.map((treatment) => (
                <motion.li
                  key={treatment.path}
                  className="mb-2"
                  whileHover={{ scale: 1.02 }}
                  transition={{ type: "spring", stiffness: 120 }}
                >
                  <Link
                    to={treatment.path}
                    className={`btn w-100 ${
                      location.pathname === treatment.path
                        ? "btn-primary"
                        : "btn-outline-primary"
                    }`}
                  >
                    {treatment.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </Card.Body>
        </Card>
      </motion.div>

      {/* Book Appointment Card */}
      <motion.div
        className="mb-4"
        variants={cardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Card className="shadow-sm">
          <Card.Body>
            <h5 className="fw-bold mb-3">Book Appointment</h5>
            <Form>
              <Row className="g-3 mb-3">
                <Col md={12}>
                  <Form.Control type="text" placeholder="Name" />
                </Col>
                <Col md={12}>
                  <Form.Control type="email" placeholder="Email" />
                </Col>
                <Col md={12}>
                  <Form.Control type="text" placeholder="Mobile No" />
                </Col>
                <Col md={12}>
                  <Form.Control type="text" placeholder="Preferred Treatment" />
                </Col>
              </Row>
              <Button
                variant="warning"
                type="submit"
                className="fw-bold w-100 shadow-sm"
              >
                Book Appointment
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </motion.div>

      {/* Contact Details Card */}
      <motion.div
        variants={cardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Card className="shadow-sm">
          <Card.Body>
            <h5 className="fw-bold mb-3">Contact Us</h5>

            <p className="mb-1 d-flex align-items-center">
              <FaPhoneAlt
                className="me-2"
                style={iconStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#ffc107")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              />
              <a
                href="tel:+919511291664"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                +91 9511291664
              </a>
            </p>

            <p className="mb-1 d-flex align-items-center">
              <FaEnvelope
                className="me-2"
                style={iconStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#ffc107")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              />
              <a
                href="mailto:truptihambire111@gmail.com"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                truptihambire111@gmail.com
              </a>
            </p>

            <p className="mb-0 d-flex align-items-start">
              <FaMapMarkerAlt
                className="me-2 mt-1"
                style={iconStyle}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#ffc107")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "")}
              />
              Shop no.-5, Ground floor, Destination Ostia, Alandi - Moshi Rd, near
              axis bank, near Y junction, Moshi Gaon, Dudulgaon, Pimpri-Chinchwad,
              Maharashtra 412105
            </p>
          </Card.Body>
        </Card>
      </motion.div>
    </>
  );
}
